import React from 'react';
import MulSelector, { renderImgText } from './MultipleSelector';
import { useIntl } from 'umi';
import { useFilterOptionList } from '@/pages/intelligence/hooks/useFilterOptionList';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';

export default function GooglePlatform(props: any) {
  const { onConfirm, value = ['appstore', 'googleplay'] } = props;

  const { formatMessage } = useIntl();
  const { googlePlatformFilterOptions } = useFilterOptionList({
    formatMessage,
  });

  const optionsRender = googlePlatformFilterOptions?.map((item, idx) => ({
    value: item?.value,
    text: renderImgText(item?.text, item?.img),
  }));

  const handleChange = (next: string[]) => {
    if (onConfirm instanceof Function) {
      onConfirm(next);
    }
  };

  return (
    <MulSelector
      value={value}
      options={optionsRender}
      buttonName={formatMessage({ id: 'dbi_platform' })}
      onChange={handleChange}
    />
  );
}
